import MD5 from 'js-md5'

import packageConfig from '../../package.json'

function handlerObjKeySort(obj) {
  //排序的方法
  var newkey = Object.keys(obj)
    .sort(function (s, t) {
      //不区分大小写排序
      var a = s.toLowerCase()
      var b = t.toLowerCase()
      if (a < b) return -1
      if (a > b) return 1
      return 0
    })
    .reverse() //倒序
  //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  var newObj = {} //创建一个新的对象，用于存放排好序的键值对
  for (var i = 0; i < newkey.length; i++) {
    //遍历newkey数组
    newObj[newkey[i]] = obj[newkey[i]] //向新创建的对象中按照排好的顺序依次增加键值对
  }
  return newObj //返回排好序的新对象
}

export function addParams(config, appKey) {
  let app_key = appKey || '4cc20840626d41a69aa81617c91a25b1'
  let sign, data
  let ts = Date.parse(new Date()).toString()
  if (config.data) {
    data = handlerObjKeySort(config.data)
    sign = MD5('Front_CUMS' + packageConfig.version + ts + JSON.stringify(data) + app_key).toUpperCase()
  } else {
    sign = MD5('Front_CUMS' + packageConfig.version + ts + app_key).toUpperCase()
  }
  config.data = {
    ts: ts,
    sign: sign,
    sysName: 'Front_CUMS',
    version: packageConfig.version
  }
  if (data) {
    config.data.data = data
  }
}

